/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 9.ブロックタワーバトル */
export const template9 = {
  title: t.to('ブロックタワーバトル', 'title9'),
  desc: t.to('ブロックを積み上げていくゲームの土台部分です', 'desc9'),
  img: '../public/template/9.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="170" y="550">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="environment_v2">
        <field name="environment">seed: 8; skyType:gradient; skyColor:#24b59f; horizonColor:#eff9b7; lighting:distant; lightPosition:-1.2 0.88 -0.55;fog: 0.8; flatShading: false; playArea: 1; ground:noise; groundYScale: 4.18; groundTexture: squares; groundColor:#937a24; groundColor2:#987d2e; dressing:trees; dressingAmount: 100; dressingColor:#888b1d; dressingScale: 1; dressingVariance:10 10 10; dressingUniformScale: true; dressingOnPlayArea: 0; grid: none; gridColor: #c5a543; shadow: false</field>
        <next>
          <block type="cube_v2">
            <field name="id">block1</field>
            <field name="position-x">0</field>
            <field name="position-y">0</field>
            <field name="position-z">0</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#198cd4</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">5</field>
                <field name="scale-y">1</field>
                <field name="scale-z">5</field>
                <value name="ATTR">
                  <block type="a-static-body_v2">
                    <field name="shape">box</field>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="cube_v2">
                <field name="id">block2</field>
                <field name="position-x">0</field>
                <field name="position-y">2</field>
                <field name="position-z">0</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#ff6464</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="scale_v2">
                    <field name="scale-x">1</field>
                    <field name="scale-y">1</field>
                    <field name="scale-z">1</field>
                    <value name="ATTR">
                      <block type="a-dynamic-body_v2">
                        <field name="mass">5</field>
                        <field name="shape">box</field>
                      </block>
                    </value>
                  </block>
                </value>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>

`,
};
